import React, { Component } from 'react';
import { connect } from 'react-redux';
import CountrySongsList from '../map/CountrySongsList';
import NavigationBar from '../navigation-bar/NavigationBar';

function View(props) {
    const {
        showAddNewSongModal,
        showAddSongToPlaylistModal,
        // showCountriesListModal,
        showCountrySongsModal,
        showCreatePlaylistModal,
        showRandomSongsModal,
        showSearchSongModal,
        showSongInfoModal,
        viewOptionSelected,
        viewComponent
    } = props;

    return (
        <>
            <NavigationBar />
            {props.children}
        </>
    );
}

const mapStateToProps = state => {
    const { authenticationReducers, mapReducers, modalReducers, songsReducers } = state;
    const {
        countryNameTooltip
    } = mapReducers;
    const {
        showAddNewSongModal,
        showAddSongToPlaylistModal,
        showCountriesListModal,
        showCountrySongsModal,
        showCreatePlaylistModal,
        showRandomSongsModal,
        showSearchSongModal,
        showSongInfoModal,
        showUserPlaylistsModal,
        viewOptionSelected
    } = modalReducers;
    return {
        // allCountriesSongs: songsReducers.allCountriesSongs,
        countriesGenres: songsReducers.countriesGenres,
        countryNameTooltip,
        showAddNewSongModal,
        showAddSongToPlaylistModal,
        showCountriesListModal,
        showCountrySongsModal,
        showCreatePlaylistModal,
        showEditSongModal: modalReducers.showEditSongModal,
        showLoginModal: modalReducers.showLoginModal,
        showRandomSongsModal,
        showRegistrationModal: modalReducers.showRegistrationModal,
        showSearchSongModal,
        showSongInfoModal,
        showUserDashboardModal: modalReducers.showUserDashboardModal,
        showUserPlaylistsModal,
        viewOptionSelected
    };
};

export default connect(mapStateToProps, null)(View);